import { UUID } from 'angular2-uuid'

export class Config {
    userToken: string;
    renderJSContent: boolean;
    constructor() {
        this.renderJSContent = false;
        this.userToken = UUID.UUID();
    }
}
